import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalComponent } from '../../../../config/core.modal-helpers';
import { AdminService } from '../../../../services/core.admin.service';
import { UiService } from '../../../../services/core.ui.service';


@Component({
    selector: 'trove-delete-modal',
    template: `<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="close" (click)="doCancel()" aria-hidden="true">&times;</button>
        <h3 class="modal-title">Delete Category: {{category.title}}</h3>
    </div>
    <div class="modal-body" translate>
        Are you sure you want to delete category '{{category.title}}'' along with all subcategories?
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="doCancel()" translate>Cancel</button>
        <button class="btn btn-danger" (click)="submit()">
            <span translate>Delete</span>
        </button>
    </div>
</div>`
})
export class TroveDeleteModalComponent extends ModalComponent {

    @Input() category: any = null;

    @Output() onClose = new EventEmitter<boolean>();

    constructor(
        private adminService: AdminService,
        private uiService: UiService,
    ) { super(); }

    doClose() {
        this.close.emit(true);
    };

    doCancel() {
        this.close.emit(false);
    };

    submit() {
        this.adminService.deleteTrove(this.category.id)
            .then(() => {
                this.doClose();
                this.uiService.message.showSuccess('Deleted category ' + this.category.categoryName);
            }, () => {
                this.uiService.message.showError('Failed to delete category ' + this.category.categoryName);
            })
    };
}